module.exports = __webpack_public_path__ + "media/assets/winner.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/media/assets/winner.png
 ** module id = 3
 ** module chunks = 0 1
 **/